export default __webpack_public_path__ + "static/media/_placeholder-30x30.7593cbcb.svg";